import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import ConfirmDialog from 'components/ConfirmDialog';
import { RAILS_DATE } from 'config/constants';

import S from '../styles.scss';

const ConflictingAppointmentModal = ({ active, dates, onClose, onSubmit, tempEntry }) => {
  const whichDates = tempEntry ? tempEntry.conflicts : dates;

  const dateFormat = tempEntry ? RAILS_DATE : 'YYYY-MM-DD HH:mm:ss Z';

  const parsedDates = whichDates.map((d) => {
    const start = tempEntry ? d.start_date : d;
    const startMoment = moment(start, dateFormat);
    const end = tempEntry ? d.end_date : null;
    const endMoment = end ? moment(end, dateFormat) : null;
    return (<span key={d} className={S.mdates}>
      {(!endMoment || endMoment.isSame(startMoment, 'day')) ?
        startMoment.format('MMMM Do YYYY') :
        `${startMoment.format('MMMM Do YYYY')} - ${endMoment.format('MMMM Do YYYY')}`}
    </span>);
  });

  const confirmation = () => {
    const text1 = tempEntry ?
      'There are appointments currently scheduled during this requested time off.' :
      'This contractor has an appointment scheduled during the requested time off.';
    const text2 = tempEntry ?
      'Please check the current schedule:' :
      'Please remove the events for the following date(s) and try again:';
    return (<p>
      {text1}
      <br />
      {text2}
      <br />
      <br />
      <span className={S.mheader}>Dates:</span>
      {parsedDates}
    </p>);
  };

  const theActions = tempEntry ? ['OK', 'Cancel'] : ['OK'];

  return (<ConfirmDialog
    show={active}
    title={tempEntry ? 'Conflicting Appointments' : 'Unable to mark time off'}
    confirmation={confirmation()}
    theActions={theActions}
    okLabel={tempEntry ? 'Add Time Off Anyway' : 'OK'}
    okColor={tempEntry ? 'yellow' : 'green'}
    proceed={tempEntry ? onSubmit : onClose}
    dismiss={() => {}}
    cancel={tempEntry ? onClose : () => {}}
  />);
};

ConflictingAppointmentModal.propTypes = {
  active: PropTypes.bool,
  dates: PropTypes.arrayOf(PropTypes.string),
  onSubmit: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  tempEntry: PropTypes.object,
};

ConflictingAppointmentModal.defaultProps = {
  active: false, dates: [], tempEntry: null, onSubmit: () => {},
};

export default ConflictingAppointmentModal;



// WEBPACK FOOTER //
// ./client/app/shared/components/TimeOffTable/components/conflictingAppointmentModal.jsx